import { render, staticRenderFns } from "./ChatbotWindow.vue?vue&type=template&id=3cdbcd4f&scoped=true&"
import script from "./ChatbotWindow.vue?vue&type=script&lang=js&"
export * from "./ChatbotWindow.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotWindow.scss?vue&type=style&index=0&id=3cdbcd4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdbcd4f",
  null
  
)

export default component.exports